var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "albumItem",
      class:
        _vm.album.cover && _vm.album.cover.image
          ? "album-item"
          : "album-item default-cover",
    },
    [
      _vm.isPlaceholder
        ? _c(
            "DotsMenu",
            { ref: "dotsMenu", on: { menuToggle: _vm.menuToggle } },
            [
              _c("DotsItem", {
                attrs: { red: "", title: "Delete Album" },
                on: { click: _vm.deleteAlbumPlaceholder },
              }),
            ],
            1
          )
        : _vm.allowedActions.length && _vm.dots
        ? _c(
            "DotsMenu",
            { ref: "dotsMenu", on: { menuToggle: _vm.menuToggle } },
            [
              _vm.allowedActions.includes("share")
                ? _c("DotsItem", {
                    attrs: { title: "Share Link" },
                    on: { click: _vm.onShareAlbumClick },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.allowedActions.includes("publish")
                ? _c("DotsItem", {
                    attrs: { title: "Publish Album" },
                    on: { click: _vm.onPublishAlbumClick },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.allowedActions.includes("unpublish")
                ? _c("DotsItem", {
                    attrs: { title: "Unpublish Album" },
                    on: { click: _vm.onPublishAlbumClick },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.allowedActions.includes("rename")
                ? _c("DotsItem", {
                    attrs: { title: "Rename Album" },
                    on: { click: _vm.onRenameAlbumClick },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.allowedActions.includes("delete")
                ? _c("DotsItem", {
                    attrs: { red: "", title: "Delete Album" },
                    on: { click: _vm.deleteAlbumModalShow },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "album-item-inner",
          on: { click: _vm.onAlbumItemClick },
        },
        [
          !_vm.isTitleEditing
            ? _c("p", { staticClass: "album-title" }, [
                _vm._v("\n            " + _vm._s(_vm.title) + "\n        "),
              ])
            : _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.title,
                    expression: "title",
                  },
                  {
                    name: "click-outside",
                    rawName: "v-click-outside",
                    value: _vm.titleInputClickOutside,
                    expression: "titleInputClickOutside",
                  },
                ],
                ref: "albumTitle",
                staticClass: "album-title",
                domProps: { value: _vm.title },
                on: {
                  keydown: _vm.saveTitleClick,
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.title = $event.target.value
                  },
                },
              }),
          _vm._v(" "),
          _vm.album.cover
            ? _c("ImageItem", {
                attrs: {
                  image: _vm.album.cover.image,
                  width: "290",
                  height: "218",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isLoading
            ? _c("PreloaderComponent", {
                staticClass: "preloader-wrapper",
                attrs: { "is-absolute": true },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }